import { buildCareSymbolsRow } from './careSymbols';
import { getProductPageQrCodeImg } from './qrCode';

function emptyOr(value, fallback = '') {
  if (value === null || value === undefined || value === '') return fallback;
  return String(value);
}

function formatPrintDate(date, formatDate) {
  if (formatDate) {
    return formatDate(date);
  }
  const d = date instanceof Date ? date : new Date();
  const day = d.getDate();
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  return `${day} ${months[d.getMonth()]} ${d.getFullYear()}`;
}

export async function buildDressDeclarationPlaceholders(dress, { t, formatPrice, formatDate, salonSlug } = {}) {
  const brandName = dress?.brand_name || dress?.brandName || '';
  const rentalPrice = dress?.rental_price != null && dress.rental_price !== ''
    ? (formatPrice ? formatPrice(dress.rental_price) : dress.rental_price)
    : '';
  const sellingPrice = dress?.selling_price != null && dress.selling_price !== ''
    ? (formatPrice ? formatPrice(dress.selling_price) : dress.selling_price)
    : '';

  let arrivalDate = emptyOr(dress?.arrival_date);
  if (arrivalDate && formatDate) {
    arrivalDate = formatDate(arrivalDate);
  }

  const map = {
    '{{dress_name}}': emptyOr(dress?.name),
    '{{dress_brand_name}}': emptyOr(brandName),
    '{{dress_size}}': emptyOr(dress?.size),
    '{{dress_colour}}': emptyOr(dress?.colour),
    '{{dress_notes}}': emptyOr(dress?.notes),
    '{{rental_price}}': rentalPrice,
    '{{selling_price}}': sellingPrice,
    '{{arrival_date}}': arrivalDate,
    '{{stock_count}}': dress?.stock_count != null ? String(dress.stock_count) : '',

    '{{item_code}}': emptyOr(dress?.item_code),
    '{{country_of_origin}}': emptyOr(dress?.country_of_origin),
    '{{manufacturer}}': emptyOr(dress?.manufacturer),
    '{{importer}}': emptyOr(dress?.importer),
    '{{maintenance_procedure}}': emptyOr(dress?.maintenance_procedure),
    '{{material_composition}}': emptyOr(dress?.material_composition),
    '{{shrinkage_during_care}}': emptyOr(dress?.shrinkage_during_care),

    '{{care_symbols_with_labels}}': buildCareSymbolsRow(dress, { labels: true, t }),
    '{{care_symbols_row}}': buildCareSymbolsRow(dress, { labels: false, t }),

    '{{print_date}}': formatPrintDate(new Date(), formatDate),

    '{{qr_code}}': await getProductPageQrCodeImg(salonSlug, dress?.id)
  };

  return map;
}
